export const COUNTY_DEPENDENT_FIELD = ["state", "city", "postalCode", "county"];

export const COUNTRY_WITH_STATES = ["US", "CA", "IN", "AR", "BR","AU"];
export const COUNTRY_WITH_COUNTY = ["US", "CA"];

//for google address matching long label that is different from our country label
export const LOCAL_COUNTRY_MATCH = ["US"];